import React, { useMemo, useState } from 'react'
import { ReactComponent as Arrow } from './icons/arrow.svg'
import { useDetectClickOutside } from 'react-detect-click-outside'
import { getLevelName } from '../../../../helpers/levels'
import BottomSheet from '../../../BottomSheet'
import useDetectDevice from '../../../../hooks/useDetectDevice'
import { captureEvent } from '../../../../analytics'
import { analyticsEvents } from '../../../../analytics/events'

function LevelPicker({ className = '', selectedLine, selectedLevel, onLevelSelected, ...props }) {
  const [toggled, setToggled] = useState(false)
  const ref = useDetectClickOutside({
    onTriggered: () => {
      setToggled(false)
    },
  })

  const levels = useMemo(() => {
    return selectedLine.unit_type_levels.map((l) => ({ id: l.id, data: l, label: getLevelName(l) }))
  }, [selectedLine])

  const { isMobile, isDesktop } = useDetectDevice()

  return (
    <div className={`${className}`} ref={ref}>
      <div
        role="button"
        className={`bg-white shadow rounded-[4px] flex items-center justify-center h-[32px] w-max`}
        onClick={() => {
          captureEvent(analyticsEvents.LEVEL_TAPPED)
          setToggled(!toggled)
        }}
      >
        <div className="px-[12px] text-[#3D4256] font-medium text-[14px] py-[7px] block">
          <>
            <span className="opacity-40">Floor</span>
            <span> #{selectedLevel.floor_number}</span>
          </>
        </div>
        <div
          className={`h-full cursor-pointer flex items-center justify-center border-l-[1px] border-solid border-[#BBBFCB] p-[9px]`}
        >
          <span className={`transition-all inline-block ${toggled ? 'rotate-[-180deg]' : ''}`}>
            <Arrow />
          </span>
        </div>
        {isMobile && (
          <>
            <BottomSheet
              open={toggled}
              title="Choose floor"
              onToggle={() => {
                setToggled(false)
              }}
            >
              {levels
                .filter((l) => l.id !== selectedLevel.id)
                .map((level) => (
                  <button
                    type="button"
                    onClick={() => {
                      onLevelSelected(level)
                      setToggled(false)
                    }}
                    className="hover:bg-[#e4e4e4] text-left py-[20px] font-medium text-[#3D4256] border-t-[1px] flex items-center justify-between w-full border-solid border-[#E5E7ED] first:border-t-0 px-[24px]"
                  >
                    {level.label}
                  </button>
                ))}
            </BottomSheet>
          </>
        )}
        {isDesktop && (
          <>
            {toggled && (
              <div className="w-full bg-[#fff] absolute bottom-[45px]   mt-[12px] flex flex-col overflow-hidden rounded-[6px]">
                {levels
                  .filter((l) => l.id !== selectedLevel.id)
                  .map((level) => (
                    <button
                      type="button"
                      onClick={() => {
                        onLevelSelected(level)
                        setToggled(false)
                      }}
                      className="text-[14px] hover:bg-[#e4e4e4] text-left px-[16px] py-[10px] font-medium text-[#3D4256]"
                    >
                      {level.label}
                    </button>
                  ))}
              </div>
            )}
          </>
        )}
      </div>
    </div>
  )
}

export default LevelPicker
